"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueInputDisplay = void 0;
const react_1 = __importStar(require("react"));
const filter_constants_1 = require("../../../filter.constants");
const filter_model_1 = require("../../../filter.model");
const common_1 = require("../common");
const fields_1 = require("../fields");
const ValueInputDisplay = ({ selected, onUpdateValue, field, filter, fieldSpecifier, }) => {
    const handleValueChange = (0, react_1.useCallback)((value) => onUpdateValue(value), [onUpdateValue]);
    const booleanField = filter_constants_1.BOOLEAN_FIELDS.includes(fieldSpecifier);
    const renderInput = () => {
        const sharedProps = {
            onOptionChange: handleValueChange,
            selected,
        };
        if (field === filter_model_1.FilterField.Category)
            return react_1.default.createElement(fields_1.CategorySelector, Object.assign({}, sharedProps));
        if (field === filter_model_1.FilterField.Attribute)
            return react_1.default.createElement(fields_1.AttributeValuesSelector, Object.assign(Object.assign({}, sharedProps), { filter: filter }));
        if (field === filter_model_1.FilterField.TaxonomyClass)
            return react_1.default.createElement(fields_1.TaxonomySelector, Object.assign({}, sharedProps));
        if (field === filter_model_1.FilterField.Value)
            return react_1.default.createElement(fields_1.ProductValuesContainer, { onOptionChange: handleValueChange, value: selected });
        if (booleanField)
            return react_1.default.createElement(fields_1.ActiveStatusSelector, { onOptionChange: handleValueChange, selected: selected });
        return react_1.default.createElement(common_1.TextInput, { onOptionChange: handleValueChange, value: selected });
    };
    return renderInput();
};
exports.ValueInputDisplay = ValueInputDisplay;
exports.default = exports.ValueInputDisplay;
